module.exports = __webpack_public_path__ + "files/476e5ecae787d9484c06ddbd8f7c4ef6.svg";